import moment from "moment";
import React, { useEffect, useState } from "react";
import {
  AXIOS_GET
} from "../../server/api/crud";
import Spinner from "../../Componenten/Spinner";
import {
  ChevronLeftIcon,
  ChevronRightIcon
} from "@heroicons/react/20/solid";
import { getUser, getUserdetails } from "../../Localstorage/localstorage";

function CalendlyEvents() {
  const userdetails = getUserdetails();
  const user = getUser();
  const email = user?.email || userdetails?.email;

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [lastDays, setLastDays] = useState(null);

  const [params, setParams] = useState({
    organization:
      "https://api.calendly.com/organizations/e5ba7299-d262-4435-acc9-67a68893e28f",
    status: "alles",
    count: "100",
    min_start_time: moment().startOf("month").toISOString(),
    sort: "start_time:asc",
    user: userdetails?.calendly_info?.uri,
  });

  const fetchData = async (lastDate = null) => {
    try {
      setLoading(true);
      let queryParams = {};

      if (params.status === "alles") {
        if (!params.organization || !userdetails?.calendly_info?.uri) {
          console.warn("Missing Calendly user or organization URI.");
          setLoading(false);
          return;
        }

        const minStartTime = lastDate
          ? moment(lastDate).startOf("month")
          : moment().startOf("month").toISOString();

        queryParams = new URLSearchParams({
          organization: params.organization,
          count: "100",
          min_start_time: minStartTime,
          sort: "start_time:asc",
          user: userdetails.calendly_info.uri,
          status: "active",
        }).toString();
      } else {
        queryParams = new URLSearchParams({ ...params }).toString();
      }

      const response = await AXIOS_GET(`calendly/scheduled?${queryParams}`);
      const newData = response?.data?.collection || [];
      setData(newData);
    } catch (error) {
      console.error("Error loading scheduled events:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (params.status) {
      fetchData();
    }
  }, [params.status]);

  const handleGetLastItem = async () => {
    if (lastDays) {
      setLastDays(null);
      await fetchData();
    } else {
      const last = data?.[data.length - 1]?.start_time ?? null;
      setLastDays(last);
      await fetchData(last);
    }
  };

  return (
    <div className="dark:bg-gray-900 bg-white h-max">
      {loading && <Spinner />}

      <select
        id="status"
        name="status"
        defaultValue={params.status}
        onChange={(e) => setParams((prev) => ({ ...prev, status: e.target.value }))}
        className="m-4 rounded border p-2 text-black dark:text-white bg-white dark:bg-gray-900"
      >
        <option value="alles">Alle afspraken</option>
        <option value="active">Toekomstige afspraken</option>
        <option value="canceled">Geannuleerde afspraken</option>
      </select>

      {data.length > 0 && (
        <div className="flex items-center gap-2 px-4">
          <button disabled={!lastDays} onClick={handleGetLastItem} className="px-4 border border-grey-100">
            <ChevronLeftIcon className="h-6 w-6 dark:text-white" />
          </button>
          <button className="px-4 border border-grey-100 dark:text-white rounded-l">
            {moment(data[0]?.start_time).calendar()} - {moment(data[data.length - 1]?.start_time).calendar()}
          </button>
          <button disabled={!!lastDays} onClick={handleGetLastItem} className="px-4 border border-grey-100">
            <ChevronRightIcon className="h-6 w-6 dark:text-white" />
          </button>
        </div>
      )}

      <div className="inline-block min-w-full align-middle sm:grid-cols-2 grid md:grid-cols-3 sm:px-2 lg:px-4 gap-2">
        {data.map((item, index) => (
          <div className="border rounded border-gray-300 p-2 m-4" key={index}>
            <p className="dark:text-white flex items-center text-xl">
              <div
                className={`w-2 h-2 ${item.status === "active" ? "bg-green-500" : "bg-red-500"} rounded-full mr-2`}
              />{" "}
              {item.name}
            </p>
            <p className="dark:text-white">{moment(item.start_time).format("LL")}</p>
            <time className="dark:text-white italic text-sm">
              {moment(item.start_time).format("HH:mm")} -{" "}
            </time>
            <time className="dark:text-white italic text-sm">
              {moment(item.end_time).format("HH:mm")}
            </time>

            <div>
              {item.invitees.map((invitee, idx) => (
                <div
                  title={invitee?.questions_and_answers?.[0]?.answer}
                  className="cursor-pointer flex flex-col border rounded p-2 m-4"
                  key={idx}
                >
                  <p className="dark:text-white text-sm italic">Klant</p>
                  <p className="dark:text-white text-sm">{invitee?.name}</p>
                  <p className="dark:text-white text-xs">{invitee?.email}</p>
                </div>
              ))}
            </div>

            <div>
              {item.creators.map((creator, idx) => (
                <div
                  className="flex flex-col border border-green-500 dark:bg-gray-800 rounded p-2 m-4"
                  key={idx}
                >
                  <p className="dark:text-green-500 text-sm italic">Specialist</p>
                  <p className="dark:text-white text-sm">{creator?.user_name}</p>
                  <p className="dark:text-white text-xs">{creator?.user_email}</p>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default CalendlyEvents;
